import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { AiFillCreditCard } from 'react-icons/ai'


const UpdatePaymentModal = ({ updatePayment, setUpdatePayment }) => {
    return (
        <div>
            <Transition.Root show={updatePayment} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setUpdatePayment}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c0c8d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform h-fit overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                                    <div>
                                        <div className='p-[16px_20px] border-b-[1px] border-[#ebeef1]'>
                                            <div className="font-semibold text-base text-gray-900">Update payment methods</div>
                                            <h4 className='text-sm text-[#414552]'>Manage your payment method preferences in <span className='text-[#625afa] font-semibold cursor-pointer'>Settings.</span></h4>
                                        </div>
                                        <div className="p-[10px_20px] border-b-[1px] border-[#ebeef1] flex justify-between text-[#1a1b25] text-[11px] font-medium">
                                            <span>PAYMENT METHODS</span>
                                            <span>CURRENCIES</span>
                                        </div>
                                        <div className="p-[16px_20px] border-b-[1px] border-[#ebeef1] bg-[#f6f8fa]">
                                            <div className="flex gap-4 items-center">
                                                <label className="inline-flex relative items-center gap-2 cursor-pointer" htmlFor="Invoice-1">
                                                    <input type="checkbox" id="Invoice-1" name="Invoice" className="sr-only peer" defaultChecked />
                                                    <div className="w-[30px] h-[17px] bg-gray-200 rounded-full peer peer-focus:ring-[#625afa] peer-checked:after:translate-x-[13px] peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[13px] after:w-[13px] after:transition-all peer-checked:bg-[#625afa]">
                                                    </div>
                                                </label>
                                                <button className='p-[8px] text-[#fff] rounded-[2px] bg-[#625afa]'><AiFillCreditCard /></button>
                                                <label htmlFor="Invoice-1" className='select-none font-semibold text-[#414552] text-sm cursor-pointer'>Credit or debit card</label>
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]" onClick={() => setUpdatePayment(false)}>Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Save</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default UpdatePaymentModal